var _g, _text, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeSelectequipment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_9_1",
    "data-name": "Component 9 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 162.393,
    height: 26.372,
    viewBox: "0 0 162.393 26.372",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_264",
    "data-name": "Path 264",
    fill: "#f8f8f8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 157.2098846435547 25.8719596862793 L 5.182736396789551 25.8719596862793 C 2.600673675537109 25.8719596862793 0.5000070929527283 23.64858436584473 0.5000070929527283 20.91568946838379 L 0.5000070929527283 5.456272602081299 C 0.5000070929527283 2.723376512527466 2.600673675537109 0.5000016093254089 5.182736396789551 0.5000016093254089 L 157.2098846435547 0.5000016093254089 C 159.7919616699219 0.5000016093254089 161.8926391601562 2.723376512527466 161.8926391601562 5.456272602081299 L 161.8926391601562 20.91568946838379 C 161.8926391601562 23.64858436584473 159.7919616699219 25.8719596862793 157.2098846435547 25.8719596862793 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.1827392578125 1.000001907348633 C 2.876358032226562 1.000001907348633 1 2.99908447265625 1 5.456272125244141 L 1 20.91568946838379 C 1 23.37287712097168 2.876358032226562 25.3719596862793 5.1827392578125 25.3719596862793 L 157.2098846435547 25.3719596862793 C 159.5162506103516 25.3719596862793 161.3926391601562 23.37287712097168 161.3926391601562 20.91568946838379 L 161.3926391601562 5.456272125244141 C 161.3926391601562 2.99908447265625 159.5162506103516 1.000001907348633 157.2098846435547 1.000001907348633 L 5.1827392578125 1.000001907348633 M 5.1827392578125 1.9073486328125e-06 L 157.2098846435547 1.9073486328125e-06 C 160.0722351074219 1.9073486328125e-06 162.3926391601562 2.442855834960938 162.3926391601562 5.456272125244141 L 162.3926391601562 20.91568946838379 C 162.3926391601562 23.92910575866699 160.0722351074219 26.3719596862793 157.2098846435547 26.3719596862793 L 5.1827392578125 26.3719596862793 C 2.320388793945312 26.3719596862793 0 23.92910575866699 0 20.91568946838379 L 0 5.456272125244141 C 0 2.442855834960938 2.320388793945312 1.9073486328125e-06 5.1827392578125 1.9073486328125e-06 Z",
    stroke: "none",
    fill: "#d9dbdf"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Select_Equipment_Name_Number",
    "data-name": "Select Equipment Name/Number",
    transform: "translate(10 16)",
    fontSize: 7,
    fontFamily: "PlusJakartaSans-Medium, Plus Jakarta Sans",
    fontWeight: 500,
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Select Bay Number"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M2.289,2.222a1.989,1.989,0,0,1,3.221,0h0A1.989,1.989,0,0,1,3.9,5.379h0A1.989,1.989,0,0,1,2.289,2.222Z",
    transform: "translate(155.568 16.043) rotate(180)",
    fill: "#989da9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2",
    "data-name": "Polygon 2",
    d: "M3.09,1.117a1,1,0,0,1,1.619,0L6.648,3.792a1,1,0,0,1-.81,1.587H1.96a1,1,0,0,1-.81-1.587Z",
    transform: "translate(155.568 16.043) rotate(180)",
    fill: "#989da9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSelectequipment);
export default __webpack_public_path__ + "static/media/home-selectequipment.c8c5b36b67aa82f05658c6065262d754.svg";
export { ForwardRef as ReactComponent };